import React, { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Search, Building2, MapPin, DollarSign } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

const PropertySearch = () => {
  const [searchParams, setSearchParams] = useState({
    type: "",
    saleType: "",
    location: "",
    priceRange: "",
  });

  const handleSearch = () => {
    console.log("Searching with params:", searchParams);
    // This will be connected to backend later
  };

  return (
    <section id="properties" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Find your property
          </h2>
          <p className="text-xl text-gray-600">
            Let us guide you to your next investment or leasing opportunity.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            {/* Property Type */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 flex items-center">
                <Building2 className="mr-2 text-blue-600" size={18} />
                Property Type
              </label>
              <Select
                value={searchParams.type}
                onValueChange={(value) =>
                  setSearchParams({ ...searchParams, type: value })
                }
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="land">Land</SelectItem>
                  <SelectItem value="office">Office</SelectItem>
                  <SelectItem value="retail">Retail</SelectItem>
                  <SelectItem value="special">Special Purpose</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {/* Sale or Lease */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 flex items-center">
                <DollarSign className="mr-2 text-blue-600" size={18} />
                Sale or Lease
              </label>
              <Select
                value={searchParams.saleType}
                onValueChange={(value) =>
                  setSearchParams({ ...searchParams, saleType: value })
                }
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select option" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="both">Sale & Lease</SelectItem>
                  <SelectItem value="sale">Sale</SelectItem>
                  <SelectItem value="lease">Lease</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {/* Location */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 flex items-center">
                <MapPin className="mr-2 text-blue-600" size={18} />
                Location
              </label>
              <Input
                type="text"
                placeholder="Enter location"
                value={searchParams.location}
                onChange={(e) =>
                  setSearchParams({ ...searchParams, location: e.target.value })
                }
                className="w-full"
              />
            </div>

            {/* Price Range */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 flex items-center">
                <DollarSign className="mr-2 text-blue-600" size={18} />
                Price Range
              </label>
              <Select
                value={searchParams.priceRange}
                onValueChange={(value) =>
                  setSearchParams({ ...searchParams, priceRange: value })
                }
              >
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select range" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="0-500k">$0 - $500K</SelectItem>
                  <SelectItem value="500k-1m">$500K - $1M</SelectItem>
                  <SelectItem value="1m-5m">$1M - $5M</SelectItem>
                  <SelectItem value="5m+">$5M+</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <Button
            onClick={handleSearch}
            size="lg"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold text-lg py-6 transition-all duration-300 hover:scale-[1.02] shadow-lg"
          >
            <Search className="mr-2" size={20} />
            Search Properties
          </Button>

          {/* Property Stats */}
          <div className="grid grid-cols-3 gap-6 mt-10 pt-8 border-t border-gray-200">
            <div className="text-center">
              <p className="text-3xl font-bold text-blue-600 mb-1">500+</p>
              <p className="text-gray-600 font-medium">Properties Listed</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-blue-600 mb-1">200+</p>
              <p className="text-gray-600 font-medium">Satisfied Clients</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-blue-600 mb-1">$500M+</p>
              <p className="text-gray-600 font-medium">Total Value</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertySearch;